import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

class AnalysisRestClient extends RestClient {
  async updateReference(reference) {
    const url = this.buildUrl("bulk-update-reference");
    const request = { reference: reference };
    await this.client.post(url, request);
  }
}

export const analysisRestClient = new AnalysisRestClient(
  atmoClient,
  "analysis"
);
